import React, { useState } from 'react'
import { Container, Input, FormGroup, Label, Row, Col, Button, Spinner } from "reactstrap";
import loginIcon from "../Assets/images/login-cropped.svg"
import { toast } from "react-toastify";
import { useAuth } from '../Contexts/AuthenticateProvider';
import { Link } from 'react-router-dom';
import Handler from '../Helpers/Handler'
import { reloadWindow, setCookie } from '../Helpers/Utils'

const Signup = () => {
    const { logIn } = useAuth();
    const validName = /^[a-zA-Z\s]+$/;
    const [login, setlogin] = useState({ mobile: '', otp: '', firstName: '', lastName: '' });
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState(true)
    const [disable, setDisable] = useState(false)
    const handleChange = (e) => {
        setlogin((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }
    const sendOtp = async () => {
        if (!login?.firstName?.trim() || login.firstName.trim().length < 3 || !validName.test(login.firstName.trim())) {
            toast.error('Invalid First Name');
        } else if (!login?.lastName?.trim() || login.lastName.trim().length < 1 || !validName.test(login.lastName.trim())) {
            toast.error('Invalid Last Name');
        } else if (Number(login?.mobile?.length) != 10) {
            toast.error('Invalid Mobile Number')
        } else {
            setLoading(true)
            setDisable(true)
            setTimeout(() => {
                setDisable(false)
            }, 30000);
            const response = await Handler({ method: 'POST', url: "/auth-customer/signup-otp", data: { firstName: login?.firstName, lastName: login?.lastName, phone: login?.mobile } })
            if (response?.success) {
                toast.success("Otp Sent Successfully");
                setOtp(false)
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }

    const submit = async () => {
        if (!login?.firstName?.trim() || login.firstName.trim().length < 3 || !validName.test(login.firstName.trim())) {
            toast.error('Invalid First Name');
        } else if (!login?.lastName?.trim() || login.lastName.trim().length < 1 || !validName.test(login.lastName.trim())) {
            toast.error('Invalid Last Name');
        } else if (Number(login?.otp?.length) !== 6) {
            toast.error('Invalid Mobile Number')
        } else {
            setLoading(true)
            const response = await Handler({ method: 'POST', url: "/auth-customer/signup-verify", data: { firstName: login?.firstName, lastName: login?.lastName, phone: login?.mobile, otp: login?.otp } })
            if (response?.success) {
                toast.success(response?.message);
                logIn(response?.data?.token)
                setCookie("token", response?.data?.token);
                setTimeout(() => {
                    reloadWindow()
                }, 1500)
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (otp) {
                sendOtp()
            } else {
                submit();
            }
        }
    };
    return (
        <React.Fragment>
            <Container>
                <Row className="justify-content-center align-items-center auth">
                    <Col xs={12} md={10}>
                        <Row className="login-page">
                            <Col xs={12} md={9} lg={5} className="shadow ">
                                {otp ?
                                    <>
                                        <div className="text-center">
                                            <h3 className="fw-bold mb-3">Signup</h3>
                                            <img src={loginIcon} alt="logo" className="login-icon" />
                                        </div>
                                        <FormGroup className="mt-3">
                                            <Label for="name">First Name :</Label>
                                            <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="firstName" disabled={!otp} placeholder="Enter Your First Name" value={login?.firstName} id="firstName" onChange={handleChange} />
                                        </FormGroup>
                                        <FormGroup className="mt-3">
                                            <Label for="name">Last Name :</Label>
                                            <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="lastName" disabled={!otp} placeholder="Enter Your Last Name" value={login?.lastName} id="lastName" onChange={handleChange} />
                                        </FormGroup>
                                        <FormGroup className="mt-3">
                                            <Label for="Mobile">Mobile Number :</Label>
                                            <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="mobile" disabled={!otp} placeholder="Enter Mobile Number" value={login?.mobile} id="Mobile" onChange={(e) => { (e.target.value.length <= 10 && Number(e.target.value) == e.target.value) && handleChange(e) }} />
                                        </FormGroup>
                                        <div className="text-center">
                                            {loading ? <Spinner className="spin-loader" type="grow"></Spinner>
                                                : <>
                                                    <Button className="login-submit w-100 mt-2" onClick={() => sendOtp()}>Send OTP</Button>
                                                    <div className='d-flex mt-2 justify-content-center align-items-center'> <span className='me-2'>Already you have a account ?</span><Link to={'/'}>Log In</Link></div>
                                                </>

                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="text-center">
                                            <h3 className="fw-bold mb-3">Signup</h3>
                                            <img src={loginIcon} alt="logo" className="login-icon" />
                                        </div>
                                        <FormGroup className="mt-2">
                                            <Label for='otp ' className='mt-2'>Enter OTP : </Label>
                                            <Input onKeyUp={handleKeyUp} autoComplete='off' type="text" name="otp" className='mb-2' disabled={otp} value={login?.otp} placeholder="Enter OTP" id="otp" onChange={(e) => { ((e.target.value.length <= 6 && Number(e.target.value) == e.target.value) && handleChange(e)) }} />
                                            <Button className="resend-otp  text-end ms-1" disabled={disable} onClick={() => sendOtp()}>Resend OTP ?</Button>
                                        </FormGroup>

                                        <div className="text-center">
                                            {loading ? <Spinner className="spin-loader" type="grow"></Spinner>
                                                :
                                                <>
                                                    <Button className="login-submit w-100" onClick={() => submit()}>Login</Button>
                                                </>
                                            }
                                        </div>
                                    </>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}

export default Signup